import jsSha1 from 'js-sha1';

const contrastingColor = (color: string) => (luma(color) >= 165) ? '000' : 'fff';

// color can be a hx string or an array of RGB values 0-255
const luma = (color: string) => {
  const rgb = (typeof color === 'string') ? hexToRGBArray(color) : color;
  return (0.2126 * rgb[0]!) + (0.7152 * rgb[1]!) + (0.0722 * rgb[2]!); // SMPTE C, Rec. 709 weightings
}

const hexToRGBArray = (color: string) => {
  if (color.length === 3) color =
    color.charAt(0) + color.charAt(0) +
    color.charAt(1) + color.charAt(1) +
    color.charAt(2) + color.charAt(2);
  else if (color.length !== 6)
    throw ('Invalid hex color: ' + color);
  const rgb = [];
  for (let i = 0; i <= 2; i++)
    rgb[i] = parseInt(color.substring(i * 2, i * 2 + 2), 16);
  return rgb;
}

const encodeToHexColor = (str: string) => {
  let hash = 0;
  str.split('').forEach(char => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash)
  })
  let colour = ''
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    colour += value.toString(16).padStart(2, '0')
  }
  return colour
}

export const colorStyle = (val: string | undefined, developerMode: boolean | undefined) => {
  if (!developerMode) {
    return {}; // disable debug color
  }
  const backgroundColor = hashHexColor(val);
  const color = contrastingColor(backgroundColor);
  return {
    "background-color": "#" + backgroundColor,
    "color": "#" + color,
  }
}

export const hashHexColor = (val: string | undefined) => {
  const stringHash = jsSha1.sha1(val ?? '');
  return encodeToHexColor(stringHash);
}
